<template>
  <div class="sb_scene">
    <div class="sb_scene_mobile-rotate-msg">
      <div class="sb_scene_mobile-rotate-msg_inner">
        <div class="sb_scene_mobile-rotate-msg_icon">
          <SvgIcon :icon-id="'icon_reset'" />
        </div>
        <div class="sb_scene_mobile-rotate-msg_text">
          Rotate your screen, for an optimal experience
        </div>
      </div>
    </div>

    <div
      class="sb_scene_banner-line-left"
      :style="{height: 'calc(((100vh - ' + bannerLineHeight + 'px) / 2 ) + ' + bannerLineAddedHeight +'px)'}"
    ></div>

    <div
      class="sb_scene_banner-line-right"
      :style="{height: 'calc(((100vh - ' + bannerLineHeight + 'px) / 2 ) + ' + bannerLineAddedHeight +'px)'}"
    ></div>

    <div
      id="content"
      ref="content"
      class="sb_scene_content"
      style="transform: translate(-50%, -50% ) scale(3)"
      :style="{ transform: 'translate(-50%, -50% ) translateZ(0) scale('+ scale +')'}"
    >
      <div class="sb_scene_banner">
        <div class="sb_scene_banner_inner">
          Create your own happy character
        </div>
      </div>

      <div class="sb_scene_set-body">
        <div
          ref="selectBodyLabel"
          class="sb_scene_set-body_label"
        >
          Select a body:
        </div>

        <div
          class="sb_scene_set-body_buttons"
        >
          <button
            v-for="(body, index) in bodies"
            :key="body.image"
            class="sb_scene_set-body_btn"
            :class="{'s_active': activeBodyIndex === index }"
            @click="setBody(index)"
          >
            <img :src="body.image">
          </button>
        </div>
      </div>

      <div class="sb_scene_set-bg">
        <div
          ref="selectBackgroundLabel"
          class="sb_scene_set-bg_label"
        >
          Select a background:
        </div>
        <div class="sb_scene_set-bg_buttons">
          <button
            v-for="background in backgrounds"
            :key="background.image"
            class="sb_scene_set-bg_btn"
            :class="{'s_active': activeBackground === background.image }"
            @click="setBackground(background)"
          >
            <img :src="background.image">
          </button>
        </div>
      </div>

      <div class="sb_scene_logo-toaf">
        <img
          ref="logoToaf"
          src="images/logos/toaf-logo.png"
          class="sb_scene_logo-toaf_logo"
        >
      </div>

      <div class="sb_scene_cross">
        <img
          ref="logoEvaCremers"
          src="images/logos/cross.png"
          class="sb_scene_cross_img"
        >
      </div>

      <div class="sb_scene_logo-eva-cremers">
        <img
          ref="logoEvaCremers"
          src="images/logos/logo_eva.png"
          class="sb_scene_logo-eva-cremers_logo"
        >
      </div>

      <div class="sb_scene_disclaimer">
        Save your lovely creation! Share it everywhere you can! And don’t forget to tag @EvaCremers and @TheOtherArtFair.
      </div>

      <DragCanvas
        ref="dragCanvas"
        class="sb_scene_drag-canvas"
      />

      <div class="sb_scene_buttons">
        <div class="sb_scene_buttons_inner">
          <button class="sb_scene_buttons_btn">
            <ButtonPill
              button-type="default"
              @click="reset"
            >
              Reset
            </ButtonPill>
          </button>
          <button class="sb_scene_buttons_btn">
            <ButtonPill
              button-type="default"
              @click="saveImage"
            >
              Save
            </ButtonPill>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ButtonPill from '@/components/ButtonPill';
import DragCanvas from '@/components/DragCanvas';
import anime from 'animejs';

import assets from '@/data/assets.json';

export default {
  name: 'Scene',
  components: {
    ButtonPill,
    DragCanvas
  },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      bannerLineHeight: 900,
      bannerLineAddedHeight: 150,
      backgrounds: assets.backgrounds,
      bodies: assets.bodies,
      activeBackground: null,
      activeBodyIndex: 0
    };
  },
  async mounted() {
    window.addEventListener('resize', this.setBannerLineHeight);
    setTimeout(() => {
      this.setBannerLineHeight();
    }, 0);
    this.animateBanner();
    this.animateLogoToaf();
    this.animateCross();
    this.animateLogoEvaCremers();
    this.animateCanvas();
    this.animateSelectBodyLabel(this.$refs.selectBodyLabel);
    this.animateBodyButtons();
    this.animateSelecBackrgoundLabel(this.$refs.selectBackgroundLabel);
    this.animateBackgroundButtons();
    this.animateSceneButtons();
    this.animateDisclaimer();
  },
  methods: {
    saveImage() {
      this.$refs.dragCanvas.saveImage();
    },
    setBody(index) {
      this.activeBodyIndex = index;
      this.$refs.dragCanvas.setBody(index);
    },
    setBackground({ image, logoType }) {
      // console.log(image);
      this.activeBackground = image;
      this.$refs.dragCanvas.setBackgroundPattern(image, logoType);
    },
    setBannerLineHeight() {
      const { height } = this.$refs.content.getBoundingClientRect();
      // console.log(height);
      this.bannerLineHeight = height;
      this.bannerLineAddedHeight = 150 * this.scale;
    },
    reset() {
      this.$refs.dragCanvas.reset();
    },
    animateBanner() {
      anime({
        targets: '.sb_scene_banner_inner',
        opacity: 1,
        translateY: [
          '-100px',
          0
        ],
        duration: 1200,
        delay: 400,
        easing: 'easeOutElastic(1, .6)'
      });
      anime({
        targets: '.sb_scene_banner-line-left, .sb_scene_banner-line-right',
        opacity: 1,
        duration: 1200,
        delay: 600,
        easing: 'easeOutElastic(1, .6)'
      });
    },
    animateLogoToaf() {
      anime({
        targets: '.sb_scene_logo-toaf_logo',
        opacity: 1,
        scale: [
          0,
          1
        ],
        duration: 1200,
        delay: 800,
        easing: 'easeOutElastic(1, .6)'
      });
    },
    animateLogoEvaCremers() {
      anime({
        targets: '.sb_scene_logo-eva-cremers_logo',
        opacity: 1,
        scale: [
          0,
          1
        ],
        duration: 1200,
        delay: 900,
        easing: 'easeOutElastic(1, .6)'
      });
    },
    animateCross() {
      anime({
        targets: '.sb_scene_cross_img',
        opacity: 1,
        scale: [
          0,
          1
        ],
        duration: 1200,
        delay: 850,
        easing: 'easeOutElastic(1, .6)'
      });
    },
    animateCanvas() {
      anime({
        targets: '.canvas-container',
        opacity: 1,
        scale: [
          0.8,
          1
        ],
        duration: 1200,
        delay: 600,
        easing: 'easeOutElastic(1, .7)'
      });
    },
    animateSelectBodyLabel(elem) {
      anime({
        targets: elem,
        opacity: 1,
        translateY: [
          '-20px',
          0
        ],
        duration: 1200,
        delay: 1700,
        easing: 'easeOutElastic(1, .4)'
      });
    },
    animateBodyButtons() {
      setTimeout(() => {
        anime({
          targets: '.sb_scene_set-body_btn',
          opacity: 1,
          scale: [
            0,
            1
          ],
          duration: 1200,
          easing: 'easeOutElastic(1, .4)',
          delay: anime.stagger(100, {
            start: 400
          })
        });
      }, 600);
    },
    animateSelecBackrgoundLabel(elem) {
      anime({
        targets: elem,
        opacity: 1,
        translateY: [
          '-20px',
          0
        ],
        duration: 1200,
        delay: 1800,
        easing: 'easeOutElastic(1, .4)'
      });
    },
    animateBackgroundButtons() {
      setTimeout(() => {
        anime({
          targets: '.sb_scene_set-bg_btn',
          opacity: 1,
          scale: [
            0,
            1
          ],
          duration: 1200,
          easing: 'easeOutElastic(1, .4)',
          delay: anime.stagger(100, {
            start: 400,
            direction: 'reverse'
          })
        });
      }, 600);
    },
    animateSceneButtons() {
      anime({
        targets: '.sb_scene_buttons_inner',
        opacity: 1,
        scale: [
          0,
          1
        ],
        duration: 1600,
        delay: 1600,
        easing: 'easeOutElastic(1, .5)'
      });
    },
    animateDisclaimer() {
      anime({
        targets: '.sb_scene_disclaimer',
        opacity: 1,
        duration: 1200,
        delay: 2000,
        easing: 'easeOutQuad'
      });
    }
  }
};
</script>

<style lang="scss">

  .canvas-container{
    opacity: 0;
    transform-origin: 50% 50%;
  }

  .sb_scene {
    position: absolute;
    width: 100%;
    height: 100%;

    //
    //  LOGO TOAF
    //
    &_logo-toaf {
      $logo-toaf-width: 600px;
      $logo-toaf-height: 267px;

      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-210px);
      width: $logo-toaf-width * .3;
      height: $logo-toaf-height * .3;

      &_logo {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
      }
    }

    //
    //  CROSS
    //
    &_cross{
      $cross-width: 100px;
      $cross-height: 100px;

      position: absolute;
      top: 45px;
      left: 50%;
      transform: translateX(0px);
      width: $cross-width * .22;
      height: $cross-height * .22;

      &_img {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
      }
    }

    //
    //  LOGO EVA CREMERS
    //
    &_logo-eva-cremers {
      $logo-eva-cremers-width: 593px;
      $logo-eva-cremers-height: 279px;

      position: absolute;
      top: 5px;
      left: 50%;
      transform: translateX(60px);
      width: $logo-eva-cremers-width * 0.32;
      height: $logo-eva-cremers-height * 0.32;

      &_logo {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
      }
    }

    //
    //  BANNER
    //

    &_banner {
      position: absolute;
      top: 120px;
      left: 50%;
      z-index: 999;
      transform: translateX(-50%) rotate(-2deg);
      transform-origin: 50% 50%;

      &_inner {
        background: $brand-tertiery;
        padding: 10px 20px 14px 20px;
        line-height: 1;
        font-size: 32px;
        box-shadow: 2px 2px 10px 0 rgba(black, .2), 2px 2px 5px 0 rgba(black, .3);
        color: $brand-primary;
        opacity: 0;
      }

    }
    &_banner-line-left,
    &_banner-line-right {
      position: absolute;
      width: .3vw;
      height: 100vh;
      left: 50%;
      background: rgba(black, .1);
      transform-origin: 50% 0;
      opacity: 0;

      @media (min-aspect-ratio: 16/9) {
        width: 3px;
      }
    }

    &_banner-line-left {
      transform: translateX(-16vw);
      @media (min-aspect-ratio: 16/9) {
        transform: translateX(-28vh);
      }
    }

    &_banner-line-right {
      transform: translateX(16vw);
      @media (min-aspect-ratio: 16/9) {
        transform: translateX(28vh);
      }
    }

    //
    //  CONTENT
    //

    &_content {
      position: absolute;
      width: 1600px;
      height: 900px;
      z-index: 3;
      left: 50%;
      top: 50%;

      // SHOW SAFE BORDER WITHIN SCENE
      // box-shadow: inset 0px 0px 0px 2px red;
      z-index: 3;
      backface-visibility: hidden;

      @media print {
        position: relative;
        width: inherit;
        height: inherit;
        top: inherit;
        left: inherit;
        transform: none !important;
      }
    }

    //
    //  SET BODY
    //

    &_set-body {
      position: absolute;
      z-index: 6;
      top: 30px;
      left: 15px;

      &_label {
        color: $brand-secondary;
        text-transform: uppercase;
        font-size: 20px;
        margin: 0 0 20px 0;
        opacity: 0;
      }

      &_buttons {
        display: flex;
      }

      &_btn {
        width: 80px;
        height: 80px;
        position: relative;
        margin: 0 10px 0 0;
        opacity: 0;

        &:before {
          content: '';
          position: absolute;
          z-index: 1;
          width: 100%;
          height: 100%;
          box-shadow: 0 0 0 3px rgba(#fff, .1);
          top: 0;
          left: 0;
          border-radius: 50%;
          transition: box-shadow .3s ease;
        }
        > img {
          position: absolute;
          z-index: 2;
          width: 80%;
          height: 80%;
          top: 10%;
          left: 10%;
          object-fit: contain;
          object-position: center;
        }

        &:hover {
          &:before {
            box-shadow: 0 0 0 3px rgba(#fff, .7);
          }
        }

        &.s_active {
          &:before {
            box-shadow: 0 0 0 3px $brand-secondary;
          }
        }
      }
    }

    //
    //  SET BG
    //

    &_set-bg {
      position: absolute;
      z-index: 6;
      top: 30px;
      right: 15px;

      &_label {
       color: $brand-secondary;
        text-transform: uppercase;
        font-size: 20px;
        margin: 0 0 20px 0;
        text-align: right;
        opacity: 0;
      }

      &_buttons {
        display: flex;
      }

      &_btn {
        width: 80px;
        height: 80px;
        position: relative;
        margin: 0 0 0 10px;
        opacity: 0;

        &:before {
          content: '';
          position: absolute;
          z-index: 1;
          width: 100%;
          height: 100%;
          box-shadow: 0 0 0 3px rgba(#fff, .1);
          top: 0;
          left: 0;
          border-radius: 50%;
          transition: box-shadow .3s ease;
        }
        > img {
          position: absolute;
          z-index: 2;
          width: 80%;
          height: 80%;
          top: 10%;
          left: 10%;
          object-fit: contain;
          object-position: center;
          border-radius: 50%;
        }

        &:hover {
          &:before {
            box-shadow: 0 0 0 3px rgba(#fff, .7);
          }
        }

        &.s_active {
          &:before {
            box-shadow: 0 0 0 3px $brand-secondary;
          }
        }
      }
    }


    //
    //  BUTTONS
    //

    &_buttons {
      position: absolute;
      bottom: 75px;
      left: 50%;
      display: flex;
      transform-origin: 50% 50%;
      transform: translateX(-50%);

      &_inner {
        opacity: 0;
      }

      &_btn {
        margin: 0 1rem;
      }
    }

    //
    //  DRAG CANVAS
    //

    &_drag-canvas {
      position: absolute;
      top: 180px;
      left: 0;
      width: 1600px;
      height: 600px;
    }


    //
    //  MOBILE ROTATE MESSAGE
    //
    &_mobile-rotate-msg {
      position: absolute;
      z-index: 9999;
      display: none;
      pointer-events: none;
      color: $brand-white;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      width: 100%;
      height: 100vh;
      background: rgba($brand-primary, .8);

      @media screen and (max-width: 600px) and (orientation:portrait) {
        display: flex;
        pointer-events: inherit;
      }


      &_inner {
        max-width: 300px;
        display: flex;
        transform: rotate(-2deg);
      }
      &_icon {
        font-size: 50px;
      }
      &_text {
        padding: 0 0 0 1rem;
      }
    }


    //
    //  DISCLAIMER
    //
    &_disclaimer {
      position: absolute;
      width: 100%;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
      width: 600px;
      text-align: center;
      margin: 0 auto;
      font-size: 17px;
      color: $brand-secondary;
      opacity: 0;
    }
  }


</style>
